<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
    

        <!-- LIST -->
        <el-col :span="24">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title"> Classrooms Search</h4>
           
            </div>
            <div v-if="error">{{error}}</div>
            <el-row style="margin-top:30px; margin-bottom: 10px">
              
                Filter Classrooms
                <br><br>
                <el-form label-position="top"  size="small" >  

                  <el-col :span="18" style="">

                    <el-select
                      size="small"
                      class="form-group border-input"
                      placeholder="Select Days"
                      v-model="days"
                      @change="getClassrooms"
                    >
                    
                      <el-option
                        v-for="day in daysArray"
                        class="select-default"
                        :value="day.value"
                        :label="day.label"
                        :key="day.value"
                      ></el-option>
                    </el-select> 

                    <el-select
                              class=""
                              size="small"
                              placeholder="Select month"
                              v-model="monthValue"
                              @change="calculateMonth"
                              no-data-text="Select Term First!"
                              >
                      <el-option v-for="option in searchMonth"
                                class="select-danger"
                                :value="option.value"
                                :label="option.label"
                                :key="option.label">
                      </el-option>
                    </el-select>

                    <el-select
                              class=""
                              size="small"
                              placeholder="Select year"
                              v-model="monthModifier"
                              @change="calculateMonth"
                              no-data-text="Select Term First!"
                              >
                      <el-option v-for="option in searchYear"
                                class="select-danger"
                                :value="option.value"
                                :label="option.label"
                                :key="option.label">
                      </el-option>
                    </el-select>

                    <el-select
                      size="small"
                      class="form-group border-input"
                      placeholder="Select Country"
                      v-model="country"
                      @change="getTownsByCountry"
                    >
                      <el-option
                        v-for="(country,index) in countries"
                        class="select-default"
                        :value="country"
                        :label="index"
                        :key="index"
                      ></el-option>
                    </el-select>
                      
                    
                    <el-select
                      size="small"
                      class="form-group border-input"
                      placeholder="Select Location"
                      v-model="town"
                      v-if="showTowns"
                      @change="getClassrooms"
                    >
                      <el-option
                        v-for="(town,index) in towns"
                        class="select-default"
                        :value="town.town"
                        :label="town.town"
                        :key="index"
                      ></el-option>
                    </el-select>

                  </el-col>

                  <el-col :span="24" style="">

                    <div>
                      <el-radio-group size="medium" v-model="unassigned" @change="getClassrooms">
                        <el-radio-button label="all">All</el-radio-button>
                        <el-radio-button label="true">Tutor assigned</el-radio-button>
                        <el-radio-button label="false">No tutor assigned</el-radio-button>
                      </el-radio-group>
                      <el-select
                      size="small"
                      class="form-group border-input"
                      placeholder="Filter by Tutor"
                      v-model="tutor"
                      clearable 
                      @change="getClassrooms"
                    >
                      <el-option
                        v-for="tutor in tutors"
                        class="select-default"
                        :value="tutor.id"
                        :label="tutor.firstname + ' ' + tutor.lastname"
                        :key="tutor.id"
                      ></el-option>
                    </el-select>
                     <el-button type="danger" size="small" round @click="resetFilters">Reset</el-button>
                    </div>


                  </el-col>
                
                  
                </el-form>

            </el-row>

            <div class="table-responsive">
              <data-tables-server
                class="table-shopping"
                style="width: 100%"
                :data="classrooms"
                :tool-bar="false"
              
                :total="total"
                :loading="loadingClassrooms"
                @query-change="getClassrooms"
            
              >
                <el-table-column type="expand">
                      <template slot-scope="props">
                        <el-col :span="24" :offset="1">
                          <i class="el-icon-loading" v-if="loading"></i>
                          <p v-if="props.row.tutor">
                            <strong>Tutor:</strong>
                            {{props.row.tutor.firstname}} {{props.row.tutor.lastname}} <router-link :to="'/tutors/edit/'+props.row.tutorId">
                                <span class="ti-new-window"></span>
                              </router-link>
                          </p>
                          <p v-if="props.row.venue && props.row.venue.name != 'Online'">
                            <strong>Venue:</strong>
                            {{props.row.venue.name}}, {{props.row.venue.line1}}, {{props.row.venue.town}} <router-link :to="'/classroom/venue/edit/'+props.row.venue.id">
                                <span class="ti-new-window"></span>
                              </router-link>
                            <br />
                          </p>
                          <p v-if="props.row.venue && props.row.venue.name == 'Online'">
                            <strong>Venue:</strong>
                             <router-link :to="'/classroom/venue/edit/'+props.row.venue.id">
                                Virtual Online Course <span class="ti-new-window"></span>
                              </router-link>
                            <br />
                          </p>
                          <p>
                            <strong>Attendees:</strong>
                            <br />
                            <el-tag
                              size="mini"
                              type="success"
                              v-for="(attendee,index) in props.row.attendees"
                              :key="index"
                            >
                              {{attendee.customer.firstname}} {{attendee.customer.lastname}}
                              <router-link :to="'/customer/edit/'+attendee.customer.id">
                                <span class="ti-new-window" style="color:#fff;"></span>
                              </router-link>
                            </el-tag>
                          </p>
                        </el-col>
                      </template>
                    </el-table-column>
                    <el-table-column label="Type" min-width="6">
                      <template slot-scope="props">
                        <span class="label label-primary" v-if="props.row['length'] == '2'">Weekend</span>
                        <span class="label label-warning" v-if="props.row['length'] == '3'">Weekday</span>
                        <span class="label label-danger" v-if="props.row['length'] == '4'">V. Weekend</span>
                        <span class="label label-success" v-if="props.row['length'] == '6'">V. Weekday</span>
                        <span class="label label-info" v-if="props.row['length'] == '5'">V. OTP</span>

                      </template>
                    </el-table-column>
                    <el-table-column label="Status" min-width="6">
                      <template slot-scope="props">
                        <span class="label label-danger" v-if="props.row.historic == '1' && props.row.isPublic == '0'">Cancelled</span>
                        <span class="label label-warning" v-if="props.row.historic != '1' && props.row.isPublic == '0'">Inactive</span>
                        <span class="label label-success" v-if="props.row.historic != '1' && props.row.isPublic == '1'">Active</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="Date" min-width="12" prop="startDate" sortable>
                      <template slot-scope="props"><strong>Start:</strong> {{props.row.startDate | moment('ddd, MMM Do, YYYY')}}<br><strong>End:</strong> {{props.row.endDate | moment('ddd, MMM Do, YYYY')}}</template>
                    </el-table-column>
                    <el-table-column label="Sessions" min-width="12" v-if="days > 3">
                      <template slot-scope="props">
                        <span v-if="props.row.code != 'flexible' && props.row.sessions.length>0">
                          <strong>Times: </strong><br>
                          {{props.row.startDate+' '+props.row.startTime | correctTime}} - {{props.row.startDate+' '+props.row.endTime | correctTime}}<br><br>
                          <strong>Dates: </strong><br>
                          <span v-if="props.row.sessions[0]">1. {{props.row.sessions[0] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[1]">2. {{props.row.sessions[1] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[2]">3. {{props.row.sessions[2] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[3]">4. {{props.row.sessions[3] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[4]">5. {{props.row.sessions[4] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[5]">6. {{props.row.sessions[5] | moment('ddd, MMM Do')}}</span>
                        </span>
                        <span v-if="props.row.code == 'flexible'">
                          <strong>Flexible holding course</strong>
                        </span>
                        <span v-if="!props.row.sessions">
                          <strong>No sessions</strong>
                        </span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Code" min-width="7">
                      <template slot-scope="props">{{props.row.code}}</template>
                    </el-table-column>

                    <el-table-column label="Meeting Details" min-width="12" v-if="days > 3">
                      <template slot-scope="props">
                        <span v-if="props.row.meetingID">
                          <strong>ID: </strong>{{props.row.meetingID}}<br>
                        </span>
                        <span v-if="props.row.meetingUrl">
                          <strong>URL: </strong><a :href="props.row.meetingUrl">{{props.row.meetingUrl}}</a><br>
                        </span>
                        <span v-else>
                          No meeting details
                        </span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Occupancy" min-width="8" prop="numAttendees" sortable align="center">
                      <template slot-scope="props">
                        <strong>{{props.row.numAttendees}} / {{props.row.maxAttendees}}</strong><br>
                        <small
                          class="label label-info"
                          v-if="props.row.maxAttendees - props.row.numAttendees === 0"
                        >Full</small>
                        <small
                          class="label label-danger"
                          v-if="props.row.numAttendees === 0"
                        >Empty</small>
                      </template>
                    </el-table-column>

                    <el-table-column label="Venue" min-width="15" v-if="days < 4">
                      <template slot-scope="props">{{props.row.venue.name}}</template>
                    </el-table-column>

                    <el-table-column label="Town" min-width="15" v-if="days < 4">
                      <template slot-scope="props">{{props.row.venue.town}}</template>
                    </el-table-column>

                    <el-table-column label="Tutor" min-width="15" align="center">
                      <template slot-scope="props">
                        <el-select
                          size="large"
                          clearable
                          class="form-group border-input"
                          placeholder="Select Tutor"
                          v-model="props.row.tutorId"
                          value-key="id"
                        >
                        <!-- DISPLAY CORRECTLY IF NO TUTORS ARE AVAILABLE (OLDER CLASSROOMS)-->
                        <el-option
                          v-if="props.row.tutorId && props.row.tutor"
                          class="select-default"
                          :value="props.row.tutorId"
                          :label="props.row.tutor.firstname + ' ' + props.row.tutor.lastname"
                          :key="props.row.tutorId+'assigned'"
                        ></el-option>
                        <el-option
                          v-for="tutor in props.row.aTutors"
                          class="select-default"
                          :value="String(tutor.id)"
                          :label="tutor.firstname + ' ' + tutor.lastname"
                          :key="String(tutor.id)"
                        ></el-option>
                        </el-select>
                        <!--<button type="button" class="el-button el-button--info el-button--mini is-round" size="mini" @click="changeTutor(props.row.id,props.row.tutorId)">Change Tutor</button>-->
                      </template>
                    </el-table-column>

                    <el-table-column label="Notes" min-width="20" align="center">
                      <template slot-scope="props">
                        <textarea width="90%" style="width:90%" rows="5" v-model="props.row.notes"></textarea><br>
                        <!--<button type="button" class="el-button el-button--info el-button--mini is-round" size="mini" @click="saveNote(props.row.id,props.row.notes)">Save Note</button>-->
                      </template>
                    </el-table-column>

                    <el-table-column min-width="5" label="Options" class="td-text">
                      <template slot-scope="props">
                        <router-link type="button" class="el-button el-button--success el-button--mini is-round" :to="'/classroom/edit/' +props.row.id">Edit</router-link><br>
                        <button type="button" class="el-button el-button--info el-button--mini is-round" style="margin-top:10px;" @click="saveChanges(props.row.id,{note: props.row.notes, tutorId: props.row.tutorId})">Save</button>
                      </template>
                    </el-table-column>
              </data-tables-server>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import json from "../../data/countries_filter.json";
import gql from "graphql-tag";
import moment from "moment";
export default {

  props: ["property", "value"],
  data() {
    return {
      countries: json,
      towns: {},
      town: null,
      country: 'Any',
      showTowns: false,
      loadingClassrooms: false,
      customerTitles: ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof", "Rev"],
      classrooms: [],
      customer: {},
      tutors: [],
      tutor: '',
      dialogVisible: false,
      loading:false,
      error: null,
      total: 0,
      days: 999,
      unassigned: 'all',
      daysArray: [
        {
          value: 999,
          label: 'All Classrooms'
        },
        {
          value: 2,
          label: 'Weekend Classrooms (20 hour)'
        },
        {
          value: 3,
          label: 'Weekday Classrooms (30 hour)'
        },
        {
          value: 4,
          label: 'Weekend Virtual (20 hour)'
        },
        {
          value: 6,
          label: 'Weekday Virtual (30 hour)'
        },
        {
          value: 5,
          label: 'OTP Virtual'
        }
      ],
      selectedProperty:'',
      selectedValue:'',
      searchMonth:[
        {value:"1",label:"January"},
        {value:"2",label:"February"},
        {value:"3",label:"March"},
        {value:"4",label:"April"},
        {value:"5",label:"May"},
        {value:"6",label:"June"},
        {value:"7",label:"July"},
        {value:"8",label:"August"},
        {value:"9",label:"September"},
        {value:"10",label:"October"},
        {value:"11",label:"November"},
        {value:"12",label:"December"},
      ],
      searchYear:[
        {value:"0",label:"This year"},
        {value:"-12",label:"Last Year"},
        {value:"+12",label:"Next Year"}
      ],
      monthValue: '1',
      monthModifier: '0',
      currentProp: this.$props.property,
      currentVal: this.$props.value
    };
  },

  methods: {

    async getClassrooms() {

        console.log('town',this.town);
        console.log('country',this.country);

        if(this.country == 'Online'){
          this.town = 'Online'
        }

        if(this.country == 'Any'){
          this.town = null
        }

        this.loadingClassrooms = true;

        var property = this.currentProp;
        var value = this.currentVal;
        
        var length = this.days === 999 ? "_neq" : "_eq"
        var tutorAssigned = this.unassigned === 'true' ? false : true
        var tutor = this.tutor

        let qWhere;
        if (property === 'code') {
          qWhere = `where:{code: {_eq: "${value}"}}`;
        }
        if (property === 'status') {
          if(property == 'cancelled') {
            qWhere = `where: {_and: {historic: {_eq: "1"}, isPublic: {_eq: "0"}, startDate: {_gte: "${moment().month(0).startOf('month').format("YYYY-MM-DD")}"}, length: {${length}: "${this.days}"}`;
          }
          if(property === 'inactive') {
            qWhere = `where: {_and: {historic: {_neq: "1"}, isPublic: {_eq: "0"}, startDate: {_gte: "${moment().month(0).startOf('month').format("YYYY-MM-DD")}"}, length: {${length}: "${this.days}"}`;
          }
          if(property === 'active') {
            qWhere = `where: {_and: {historic: {_neq: "1"}, isPublic: {_eq: "1"}, startDate: {_gte: "${moment().month(0).startOf('month').format("YYYY-MM-DD")}"}, length: {${length}: "${this.days}"}`;
          }
        }  
        if (property === 'month') {
          qWhere = `where:{_and: {startDate: {_gte: "${moment().month(value-1).startOf('month').format("YYYY-MM-DD")}",_lte:"${moment().month(value-1).endOf('month').format("YYYY-MM-DD")}"}, length: {${length}: "${this.days}"}`;
        }

        if(this.unassigned != 'all' && this.tutor == ''){
          qWhere += `, tutorId: {_is_null: ${tutorAssigned}}`
        }

        if(this.tutor != ''){
          qWhere += `, tutorId: {_eq: ${tutor}}`
        }

        if(this.town && this.town != null){
          var fixTown = "";
          this.town == 'chester' || this.town == 'Chester' ? fixTown = 'chester' : fixTown = "%"+this.town+"%";
          qWhere += `, venue: {town: {_ilike: "${fixTown}"}}`
        }

        qWhere += `}}`
        
        this.$apollo
          .query({
            query: gql`
              {
                ClassRoom(
                  limit: 100,
                  ${qWhere},
                  order_by: {startDate: asc}
                ) {
                  id
                  additionalCost
                  allRatingsPercentage
                  code
                  courseRatingPercentage
                  dateCreated
                  dateUpdated
                  endDate
                  startTime
                  endTime
                  isOnline
                  historic
                  isPublic
                  length
                  sessions
                  meetingUrl
                  meetingID
                  maxAttendees
                  numAttendees
                  numberOfTens
                  tutorId
                  startDate
                  venueId
                  notes
                  availableTutors
                  aTutors{
                    id
                    firstname
                    lastname
                  }
                  venue {
                    id
                    name
                    town
                  }
                  attendees {
                    customer {
                      id
                      firstname
                      lastname
                    }
                  }
                  tutor {
                    email
                    emailVerified
                    firstname
                    id
                    isActive
                    lastname
                    rating
                    username
                  }
                }
              

            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
        })
        .then(result => {
          this.classrooms = result.data.ClassRoom;
          this.total = this.classrooms.length;
          this.loadingClassrooms = false;
        })
    },

    getTownsByCountry(country) {
      //console.log('country',country);
      if(country && country == 'Online') {
        this.showTowns = false;
        this.town = 'Online';
        this.getClassrooms();
      }
      if(country && country != 'Online' && country != 'Any'){
      
      this.$apollo
        .query({
          query: gql`
            {
              ClassRoomVenue(where: {country: {_eq: "${country}"}}, distinct_on: town) {
                town
              }
            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
        })
        .then(result => {
          this.towns = result.data.ClassRoomVenue;
          this.showTowns = true;
        })

      } else {
        this.showTowns = false;
        this.town = null;
        this.getClassrooms();
      }
    },

    calculateMonth(){
      this.currentVal = parseInt(this.monthValue) + parseInt(this.monthModifier);
      this.currentProp = 'month';
      this.getClassrooms();
    },

    async getTutors() {
      this.$apollo
        .query({
          query: gql`
            {
              Tutor(limit: 100, where: {isActive: {_eq: 1}}, order_by: {firstname: asc}) {
                id
                firstname
                lastname
              }
            }
          `,
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.tutors = response.data.Tutor;
        });
    },

    resetFilters(){
      this.towns = {}
      this.town = null
      this.country = 'Any'
      this.showTowns = false
      this.classrooms = []
      this.customer = {}
      this.tutors = []
      this.tutor = ''
      this.days = 999
      this.unassigned = 'all'
      this.currentProp = this.$props.property
      this.currentVal = this.$props.value
      this.getClassrooms();
    },

    saveChanges(id,data) {
      //note = this.stripHTML(note);
      console.log(data);
      data.tutorId = data.tutorId || null;
      let q = gql`
      mutation saveChanges($note: String, $tutorId: Int) {
        update_ClassRoom(
          where: {id: {_eq: ${id}}}, 
          _set: {
            notes: $note,
            tutorId: $tutorId
          }
        ) 
        {
          returning {
            id
            notes
            tutorId
            tutor {
              email
              emailVerified
              firstname
              id
              isActive
              lastname
              rating
              username
            }
          }
        }
      }`;
      this.$apollo
        .mutate({
          mutation: q,
          variables: {
            note: data.note,
            tutorId: data.tutorId
          }
        })
        .then(result => {
          console.log(result);
          this.$notify({
            title: "Updated",
            message: "Saved",
            type: "success"
        });
      });
    },
    
    /* --- NO LONGER NEEDED ---
    async loadData() {
      this.loadingClassrooms = true;
      if (this.$props.property) {
        // if its an id which is a number ilike won't work
        let qWhere;
        if (this.$props.property == "code") {
          qWhere = `where:{code: {_eq: "${this.$props.value}"}}`;
        }
        if (this.$props.property == "status") {
          if(this.$props.value == 'cancelled') {
            qWhere = `where: {_and: {historic: {_eq: "1"}, isPublic: {_eq: "0"}, startDate: {_gte: "${moment().month(0).startOf('month').format("YYYY-MM-DD")}"}}}`;
          }
          if(this.$props.value == 'inactive') {
            qWhere = `where: {_and: {historic: {_neq: "1"}, isPublic: {_eq: "0"}, startDate: {_gte: "${moment().month(0).startOf('month').format("YYYY-MM-DD")}"}}}`;
          }
          if(this.$props.value == 'active') {
            qWhere = `where: {_and: {historic: {_neq: "1"}, isPublic: {_eq: "1"}, startDate: {_gte: "${moment().month(0).startOf('month').format("YYYY-MM-DD")}"}}}`;
          }
        }  
        if (this.$props.property == "month") {
          qWhere = `where:{startDate: {_gte: "${moment().month(this.$props.value-1).startOf('month').format("YYYY-MM-DD")}",_lte:"${moment().month(this.$props.value-1).endOf('month').format("YYYY-MM-DD")}"}}`;
        } 
        this.$apollo
        
          .query({
            // desc_nulls_last filters out any null data
            fetchPolicy: 'no-cache',
            query: gql`
            {
              ClassRoom(
              
              
               ${qWhere}, order_by: {startDate: asc}
              ) {
                  id
                  additionalCost
                  allRatingsPercentage
                  code
                  courseRatingPercentage
                  dateCreated
                  dateUpdated
                  endDate
                  startTime
                  endTime
                  isOnline
                  historic
                  isPublic
                  length
                  sessions
                  meetingUrl
                  meetingID
                  maxAttendees
                  numAttendees
                  numberOfTens
                  tutorId
                  startDate
                  venueId
                  notes
                  venue {
                    id
                    name
                    town
                  }
                  attendees {
                    customer {
                      id
                      firstname
                      lastname
                    }
                  }
                  tutor {
                    email
                    emailVerified
                    firstname
                    id
                    isActive
                    lastname
                    rating
                    username
                  }
                }
               
            }
          `,
            // can get error if needed
            error(error) {
              this.error = JSON.stringify(error);
            }
          })
          .then(response => {
            this.classrooms = response.data.ClassRoom;
            this.total = this.classrooms.length;
           // this.total = response.data.Customer_aggregate.aggregate.count;
            this.loadingClassrooms = false;
          });
      } 
    }
      */
  },

  watch: {
    "$route.params.value": function(value) {
      console.log('value: ',this.$props.value)
      this.getTutors();
      if (this.$props.property == "month") {
        if(this.$props.value-1 < 0){
          this.monthModifier = '-12';
        } else if(this.$props.value-1 > 12) {
          this.monthModifier = '+12';
        } else{
          this.monthModifier = '0';
        }
        this.monthValue = parseInt(this.$props.value) - parseInt(this.monthModifier);
        this.monthValue = String(this.monthValue);
        this.calculateMonth();
      } else{
        this.getClassrooms();
      }
    }
  },
  mounted() {
    console.log('props: ',this.$props);
    this.getTutors();
    if (this.$props.property == "month") {
      if(this.$props.value-1 < 0){
        this.monthModifier = '-12';
      } else if(this.$props.value-1 > 12) {
        this.monthModifier = '+12';
      } else{
        this.monthModifier = '0';
      }
      this.monthValue = parseInt(this.$props.value) - parseInt(this.monthModifier);
      this.monthValue = String(this.monthValue);
      this.calculateMonth();
    } else{
      this.getClassrooms();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Classrooms/Search.vue